export default __webpack_public_path__ + "static/media/logo.bdba7f9b.png";